import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  const location = useLocation();
  const currentCategory = location.pathname.split('/category/')[1] || '';

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            影片分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            涵盖电影、电视剧、综艺、动漫四大品类，满足您的多样化观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className={`group flex flex-col items-center gap-3 p-6 rounded-xl border transition-all cursor-pointer ${
                currentCategory === cat.id
                  ? 'bg-primary-500/10 border-primary-500/30'
                  : 'bg-background-50 border-background-200/70 hover:border-primary-500/20 hover:bg-primary-500/5'
              }`}
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl transition-all ${
                currentCategory === cat.id
                  ? 'bg-primary-500 text-foreground-50'
                  : 'bg-background-100 text-foreground-500 group-hover:bg-primary-500/15 group-hover:text-primary-500'
              }`}>
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400">
                  {cat.count} 部资源
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}